module.exports = {
  name: 'Síntesis',
  desc: 'Televisa - síntesis',
  prefix: 'boss',
  footerText: 'Televisa síntesis | Todos los derechos reservados 2018',
  logoText: 'Síntesis',
  needLogin: false
};

